function initVariantAtcState() {
  const variantSelection = document.querySelector('[data-variant-selection]');
  if (!variantSelection || !variantSelection.getVariant || window.initVariantAtcStateRun) {
    return;
  }

  window.initVariantAtcStateRun = true;
  const applyDisabledATC = (variant) => {
    document.body.classList.toggle('mw-atc-disabled', !variant);
  };

  variantSelection.getVariant().then(applyDisabledATC);

  variantSelection.addEventListener('variant-change', e => {
    applyDisabledATC(e.detail.variant);
  });
}
function initVariantValidationFeedback() {
  const variantSelection = document.querySelector('[data-variant-selection]');
  if (!variantSelection) return;

  const atcButtons = document.querySelectorAll(
    '.product-form--atc-button, .js-go-cart-add-to-cart, .mw-apo-add-to-cart-cloned'
  );

  function getMissingVariantContainer() {
    const groups = document.querySelectorAll('[data-variant-option]');

    for (const group of groups) {

      /* SELECT DROPDOWN */
      if (group.tagName === 'SELECT') {
        const value = group.value;

        if (!value || value.trim() === '') {
          return group.closest('.options-selection__select-wrapper');
        }
        continue;
      }

      /* RADIO / SWATCH GROUP */
      const radios = group.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        const checkedRadio = group.querySelector('input[type="radio"]:checked');
        if (!checkedRadio) {
          return group.closest('fieldset');
        }
      }
    }

    return null;
  }

  function showVariantError(container) {
    if (!container) return;

    // restart animation
    container.classList.remove('variant-error-shake');
    void container.offsetWidth;
    container.classList.add('variant-error-shake');

    // avoid duplicate messages
    let error = container.querySelector('.variant-error-message');

    if (!error) {
      error = document.createElement('div');
      error.className = 'variant-error-message';
      error.textContent = 'Please, choose an option';

      container.appendChild(error);
    }
  }

  function clearVariantError(container) {
    if (!container) return;
    container.classList.remove('variant-error-shake');
    const error = container.querySelector('.variant-error-message');
    if (error) {
      error.remove();
    }
  }

  // BUTTON CLICK VALIDATION
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.product-form--atc-button, .js-go-cart-add-to-cart, .mw-apo-add-to-cart-cloned');

    if (!button) return;

    const isDisabledState =
      document.body.classList.contains('mw-atc-disabled');

    if (!isDisabledState) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const missingContainer = getMissingVariantContainer();
    showVariantError(missingContainer);
    if (missingContainer) {
      requestAnimationFrame(() => {
        missingContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    }
  }, true);

  // AUTO REMOVE ERROR ON SELECTION
  document.addEventListener('change', function (e) {
    const optionGroup = e.target.closest('fieldset') || e.target.closest('.options-selection__select-wrapper');
    if (!optionGroup) return;
    clearVariantError(optionGroup);
  });
}
function initPdpSticky() {
  initVariantAtcState();
  initVariantValidationFeedback();
  if (window.innerWidth >= 768) return;

  const sticky = document.querySelector('[data-pdp-mobile-sticky]');
  if (!sticky) return;

  if (sticky.parentNode !== document.body) {
    document.body.appendChild(sticky);
  }

  const stickyButton = sticky.querySelector('[data-sticky-atc]');
  const stickyPriceCurrent = sticky.querySelector('[data-sticky-price-current]');
  const stickyPriceCompare = sticky.querySelector('[data-sticky-price-compare]');
  const stickyTop = sticky.querySelector('[data-sticky-top]');

  const variantSelection = document.querySelector('[data-variant-selection]');
  const variantSection = document.querySelector('[data-product-option]') || document.querySelector('[data-variant-selection]');

  const getVisibleMainAtc = () => {
    const buttons = document.querySelectorAll('.product-form--atc-button, .js-go-cart-add-to-cart, .mw-apo-add-to-cart-cloned, [data-product-atc]');
    for (let i = 0; i < buttons.length; i++) {
      // Prioritize the cloned active button if present
      if (buttons[i].classList.contains('mw-apo-add-to-cart-cloned')) return buttons[i];
      if (buttons[i].offsetHeight > 0) return buttons[i];
    }
    return buttons[0];
  };

  let currentVariant = null;

  /* SHOW STICKY AFTER MAIN ATC */

  function updateStickyVisibility() {
    const header = document.querySelector('.site-header-main') || document.querySelector('header');

    const topOffset = header ? header.offsetHeight: 0;

    if (stickyTop) {
      stickyTop.style.top = `${topOffset}px`;
    }

    // Determine target scroll threshold
    const mainAtc = getVisibleMainAtc();
    if (!mainAtc) return;

    // Determine target scroll threshold
    const triggerPoint = mainAtc.getBoundingClientRect().top + window.scrollY + mainAtc.offsetHeight;
    const thresholdPassed = window.scrollY > triggerPoint - topOffset;

    if (thresholdPassed) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  // Use passive scroll event for accuracy and immediately call it once
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateStickyVisibility();
        ticking = false;
      });

      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('resize', updateStickyVisibility, { passive: true });
  updateStickyVisibility();

  /* VARIANT STATE */

  function updateStickyState(variant) {
    currentVariant = variant;
    if (!variant) {
      if (stickyButton) {
        stickyButton.textContent = 'Select Options';
        stickyButton.disabled = false;
      }
      return;
    }

    if (!variant.available) {
      if (stickyButton) {
        stickyButton.textContent = 'Sold Out';
        stickyButton.disabled = true;
      }
      return;
    }

    if (stickyButton) {
      stickyButton.textContent = 'Add to Cart';
      stickyButton.disabled = false;
    }

    if (stickyPriceCurrent) {
      stickyPriceCurrent.innerHTML = Shopify.formatMoney(
        variant.price,
        window.theme.moneyFormat
      ) + ' <span class="pdp-mobile-sticky__price-currency">USD</span>';
    }

    if (stickyPriceCompare) {
      if (variant.compare_at_price > variant.price) {
        stickyPriceCompare.innerHTML = Shopify.formatMoney(
          variant.compare_at_price,
          window.theme.moneyFormat
        ) + ' <span class="pdp-mobile-sticky__price-currency">USD</span>';
        stickyPriceCompare.classList.remove('hide');
      } else {
        stickyPriceCompare.classList.add('hide');
        stickyPriceCompare.innerHTML = '';
      }
    }
  }

  /* INITIAL VARIANT */

  if (variantSelection && variantSelection.getVariant) {
    variantSelection.getVariant().then(variant => {
      updateStickyState(variant);
    });

    variantSelection.addEventListener('variant-change', event => {
      updateStickyState(event.detail.variant);
    });
  }

  /* STICKY CTA ACTION */

  if (stickyButton) {
    stickyButton.addEventListener('click', () => {
      if (!currentVariant) {
        if (variantSection) {
          variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const firstInput = variantSection.querySelector('input, button, select');
          if (firstInput) firstInput.focus();
        }
        return;
      }
      if (!currentVariant.available) return;

      const mainAtc = getVisibleMainAtc();
      if (mainAtc) mainAtc.click();
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpSticky);
} else {
  initPdpSticky();
}